import { BookOpen01, BookOpen02, Lightbulb02, User01 } from "@untitledui/icons";
import { Link } from "react-aria-components";
import { partnerFooterLinks } from "../nav";

const icons = { "/how-it-works": Lightbulb02, "/glossary": BookOpen02, "/rules": BookOpen01, "/account": User01 } as const;

/** Help and account links at the foot of every page, so the sidebar stays short enough not to scroll. */
export const PartnerFooter = () => (
    <footer className="mx-auto mt-auto flex w-full max-w-container flex-col items-center gap-3 border-t border-secondary px-4 pt-6 pb-8 md:flex-row md:justify-between md:px-8">
        <nav aria-label="راهنما و حساب" className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
            {partnerFooterLinks.map((l) => {
                const Icon = icons[l.href as keyof typeof icons];
                return (
                    <Link key={l.href} href={l.href} className="flex items-center gap-1.5 rounded-md text-sm font-medium text-tertiary outline-focus-ring hover:text-secondary focus-visible:outline-2 focus-visible:outline-offset-2">
                        {Icon && <Icon className="size-4 text-fg-quaternary" aria-hidden="true" />}
                        {l.label}
                    </Link>
                );
            })}
        </nav>
        <p className="text-xs text-quaternary">پلتفرم بازاریابی هوشمند میزبان‌فا</p>
    </footer>
);
